import { ActivityLiteModel } from 'api-hooks/activity';
import { GuestLiteModel } from 'api-hooks/guest';
import { Expose, Type } from 'class-transformer';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

import { CommonMutationInput, SaleLiteModel, SaleModel } from '../common';

// Model
export class ActivitySaleGuestDetailsModel {
  @Type(() => ActivityLiteModel)
  activity: ActivityLiteModel;

  @Type(() => Date)
  date: Date;

  description: string;
  id: string;

  @Type(() => Number)
  price: number;

  @Type(() => Number)
  qty: number;

  status: string;

  @Expose({ name: 'total_price' })
  @Type(() => Number)
  totalPrice: number;
}

export class ActivitySaleGuestItemModel extends CommonModel {
  preferences: { id: string; name: string }[];

  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;

  @Expose({ name: 'activity_sale_guest_details' })
  @Type(() => ActivitySaleGuestDetailsModel)
  activitySaleGuestDetails: ActivitySaleGuestDetailsModel[];
}

export class ActivitySaleAddOnsItemModel extends CommonModel {
  description: string;

  @Type(() => Number)
  price: number;

  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;
}

export class ActivitySaleItemModel extends CommonModel {
  @Expose({ name: 'reschedule_fee' })
  @Type(() => Number)
  rescheduleFee?: number | null;

  @Expose({ name: 'is_grouped_price' })
  @Type(() => Boolean)
  isGroupedPrice: boolean;

  @Expose({ name: 'activity_sale_guests' })
  @Type(() => ActivitySaleGuestItemModel)
  activitySaleGuests: ActivitySaleGuestItemModel[];

  @Expose({ name: 'activity_sale_add_ons' })
  @Type(() => ActivitySaleAddOnsItemModel)
  activitySaleAddOns: ActivitySaleAddOnsItemModel[];
}

export class ActivitySaleLiteModel extends SaleLiteModel {}

export class ActivitySaleModel extends SaleModel {
  @Expose({ name: 'activity_sales' })
  @Type(() => ActivitySaleItemModel)
  activitySales: ActivitySaleItemModel[];
}

export class ActivitySaleGuestModel extends CommonModel {
  preferences: { id: string; name: string }[];

  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;

  @Expose({ name: 'activity_sale_guest_details' })
  @Type(() => ActivitySaleGuestDetailsModel)
  activitySaleGuestDetails: ActivitySaleGuestDetailsModel[];
}

export class ActivitySaleDetailModel extends CommonModel {
  @Expose({ name: 'activity_sale_add_ons' })
  @Type(() => ActivitySaleAddOnsItemModel)
  activitySaleAddOns: ActivitySaleAddOnsItemModel[];

  @Expose({ name: 'activity_sale_guests' })
  @Type(() => ActivitySaleGuestModel)
  activitySaleGuests: ActivitySaleGuestModel[];

  @Expose({ name: 'is_grouped_price' })
  @Type(() => Boolean)
  isGroupedPrice: boolean;
}

// Input

export class getActivitySalesInput {
  params: CommonParamInput & {
    selection?: string;
  };
}

export class getActivitySaleInput {
  id: string;
}

export class ActivitySaleActivitySaleAddOnsMutationInput {
  id?: string;
  description: string;
  price: number;
  guestId: string;
}

export class ActivitySaleActivitySaleGuestDetailMutationInput {
  id?: string;
  activityId: string;
  price: number;
  qty: number;
  totalPrice: number;
  description: string;
}

export class ActivitySaleActivitySaleGuestMutationInput {
  id?: string;
  guestId: string;
  preferences: string[];
  activitySaleGuestDetails: ActivitySaleActivitySaleGuestDetailMutationInput[];
}

export class ActivitySaleActivitySaleMutationInput {
  id?: string;
  activitySaleAddOns: ActivitySaleActivitySaleAddOnsMutationInput[];
  activitySaleGuests: ActivitySaleActivitySaleGuestMutationInput[];
  isGroupedPrice: boolean;
}

export class ActivitySaleMutationInput extends CommonMutationInput {
  activitySales: ActivitySaleActivitySaleMutationInput[];
}

export class ActivitySaleRescheduleItemInput extends ActivitySaleActivitySaleMutationInput {
  rescheduleFee: number;
}

export class ActivitySaleRescheduleMutationInput {
  transactionAt: Date | null;
  total: number;
  activitySales: {
    id: string;
    isGroupedPrice: boolean;
    activitySaleGuests: {
      guestId: string;
      preferences: string[];
      id: string;
      activitySaleGuestDetails: {
        activityId: string;
        date: Date;
        price: number;
        description: string;
        id: string;
      }[];
    }[];
    activitySaleAddOns: {
      guestId: string;
      description: string;
      price: number;
      id: string;
    }[];
  }[];
}

export class ActivitySaleReschedulePutInput {
  activitySaleId: string;
  body: ActivitySaleRescheduleMutationInput;
}

export class ActivitySaleUpdateInput {
  activitySaleId: string;
  body: ActivitySaleMutationInput;
}

export class ActivitySaleDeleteInput {
  id: string;
}
